"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function merge(source, ...data) {
    for (const extra of data) {
        for (const key of Object.keys(extra)) {
            if (source[key] !== extra[key]) {
                source = Object.assign(Object.assign({}, source), extra);
                break;
            }
        }
    }
    return source;
}
exports.default = merge;
